import React from "react";
import styles from "./NewsList.module.css"; // CSS 파일 import

const NewsList = ({ news }) => {
  return (
    <div className={styles.newsContainer}>
      {news.map((newsItem, index) => (
        <div key={index} className={styles.newsItem}>
          <h3 className={styles.title}>{newsItem.title}</h3>
          <p className={styles.date}>
            {new Date(newsItem.date).toLocaleString()}
          </p>
        </div>
      ))}
    </div>
  );
};

export default NewsList;
